import React, { useState, useEffect } from 'react'
import { Tabs, Tab, Box } from '@mui/material'
import { RecordContextProvider } from 'react-admin'
import { hasPermissionFunction } from 'src/helper/HasPermission'
const TabPanel = ({ children, value, index, ...props }) => {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...props}
    >
      {value === index && <>{children}</>}
    </div>
  )
}

export const TabProduct = ({ products, children, labelGetter, getStyle }) => {
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }} display={'flex'} justifyContent={'center'}>
      <Box sx={{ width: '98%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} variant='scrollable' scrollButtons='auto'>
            {products.map((product, index) => (
              ((product.status === 'AFTER_SALES_HIDDEN' && hasPermissionFunction('item', 'show_postventa')) || (
                product.status !== 'AFTER_SALES_HIDDEN')
              ) &&
              <Tab 
                style={{
                  ...getStyle(product),
                  minWidth: 'fit-content', 
                  maxWidth: '100%', 
                  whiteSpace: 'nowrap', 
                }} 
                label={((product.status === 'AFTER_SALES' || product.status === 'AFTER_SALES_HIDDEN')? 'PV - ': '') + labelGetter(product)}
                key={index} 
              />
            ))}
          </Tabs>
        </Box>
        {products.map((product, index) => (
          <TabPanel key={index} value={value} index={index} product={product}>
            <RecordContextProvider value={product} key={index}>
              {children}
            </RecordContextProvider>
          </TabPanel>
        ))}
      </Box>
    </Box>
  )
}
